import { KeyValType } from "./KeyValStore.js";

export type ProjectKeyValEntry<V = unknown, ID = string, D = string> = {
  _id: ID;
  type: KeyValType;
  key: string;
  value: V;
  created: D;
  updated: D;
  lastAccessed: D;
  projectId: string;
  userId: string
}

export type ProjectKeyValMaxAgeRule<ID = string> = {
  _id: ID;
  projectId: string;
  keyPattern: string;
  maxAgeSeconds: number;
}

// Alle RAGAI.GROUPCHAT-KeyVal-Einträge (Bot-to-Bot-Gruppenchat) bekommen diesen Prefix im `type`-Feld,
// damit sie sich als "Systemeinträge" von regulären Collections (z. B. "custom", "supervisor") in der
// allgemeinen Projekt-KeyVal-Übersicht unterscheiden/filtern lassen. Der Kanalname selbst (z. B.
// "Gruppenchat" oder ein selbst angelegter Kanal) bleibt für den Nutzer unprefixed – der Prefix existiert
// nur auf Storage-Ebene. Wird sowohl von admin- als auch bot-App und vom Server genutzt.
export const GROUPCHAT_TYPE_PREFIX = "GROUPCHAT_";

export function toGroupchatType(channel: string): string {
  return channel.startsWith(GROUPCHAT_TYPE_PREFIX) ? channel : GROUPCHAT_TYPE_PREFIX + channel;
}

export function fromGroupchatType(type: string): string {
  return type.startsWith(GROUPCHAT_TYPE_PREFIX) ? type.substring(GROUPCHAT_TYPE_PREFIX.length) : type;
}

// "Systemeinträge": Projekt-KeyVal-Einträge, die nicht von Bot-Autoren selbst angelegt wurden, sondern
// intern von RAGAI-Features (aktuell: Gruppenchat, Quiz-Verlauf) erzeugt werden. Kann bei Bedarf um
// weitere Prefixe erweitert werden.
export function isSystemKeyValType(type: string): boolean {
  return typeof type === "string" && (type.startsWith(GROUPCHAT_TYPE_PREFIX) || type.startsWith(QUIZ_TYPE_PREFIX));
}

// Alle RAGAI.QUIZ-KeyVal-Einträge (protokollierter Frage/Antwort-Verlauf eines Nutzers über alle
// Bots eines Projekts hinweg) bekommen diesen Prefix im `type`-Feld, analog zu GROUPCHAT_TYPE_PREFIX.
// Aktuell gibt es (anders als beim Gruppenchat) nur einen einzigen, festen "Kanal" (QUIZ_HISTORY_TYPE).
export const QUIZ_TYPE_PREFIX = "QUIZ_";
export const QUIZ_HISTORY_TYPE = QUIZ_TYPE_PREFIX + "history";

// Ein einzelner protokollierter Frage/Antwort-Vorgang eines Quiz-Durchlaufs. Wird als JSON-String im
// `value`-Feld eines ProjectKeyValEntry mit type=QUIZ_HISTORY_TYPE gespeichert (analog zu den
// GROUPCHAT-Nachrichten, deren `value` ebenfalls ein reiner String ist).
export type QuizAnswerLogEntry = {
  question: string;
  correctAnswer: string;
  givenAnswer: string;
  correct: boolean;
  askedAt: string;
  answeredAt: string;
  botId: string;
  botName: string;
  /** Skill-/Dokument-ID, aus der das Quiz generiert wurde (optional, vom Bot-Bauer gesetzt) */
  skillId: string;
}
